<template>
  <div class="about">
    <my-navi activeIndex="18"></my-navi>
    <el-container>
      <el-header>
        <span style="font-weight: bold; font-size: 16px;">US2CA/AU 库存价格同步工具</span>
      </el-header>
      <el-main>
        <el-card>
          <el-descriptions :column="1" border>
            <el-descriptions-item label="功能说明">
              此工具用于对比US站点和CA/AU站点的库存报告，生成库存调整文件。支持读取txt文本格式的库存报告。
            </el-descriptions-item>
            <el-descriptions-item label="文件格式">
              每行包含 seller-sku、asin、price、quantity 四部分信息，用空格分隔。
            </el-descriptions-item>
            <el-descriptions-item label="导出结果说明">
              <ul>
                <li><strong>规则1（下架检测）：</strong>自动识别US站点已下架或删除但CA/AU站点仍在售的商品，帮助排查漏下架情况。对于确认需要下架的商品，导出时quantity设为0；若无需下架，可点击删除移除该记录，不会出现在最终调价文件中。</li>
                <li><strong>规则2（价格同步）：</strong>基于US站点价格，自动计算CA/AU站点的同步价格（含运费和汇率），确保跨站点价格一致性。</li>
                <li><strong>结果整合：</strong>规则1和规则2筛选出的商品会合并到最终导出的调价模板中，方便批量操作。</li>
              </ul>
            </el-descriptions-item>
            <el-descriptions-item label="参数配置">
              <ul>
                <li>CA运费: $10, 汇率: 1.42</li>
                <li>AU运费: $150, 汇率: 1.44</li>
                <li>minimum-seller-allowed-price = price * 2/3</li>
                <li>maximum-seller-allowed-price = price * 1.5</li>
              </ul>
            </el-descriptions-item>
          </el-descriptions>
          <el-row style="margin-top: 20px;">
            <el-col :span="8">
              <el-upload
                :on-change="loadUSFile"
                :before-upload="checkTxtFile"
                :show-file-list="false"
                accept=".txt"
              >
                <el-button slot="trigger" type="primary">
                  <i class="el-icon-upload"></i>
                  上传US库存报告
                </el-button>
              </el-upload>
              <span v-if="usFileName" style="margin-left: 10px; color: #67c23a;">{{ usFileName }}</span>
            </el-col>
            <el-col :span="8">
              <el-upload
                :on-change="loadTargetFile"
                :before-upload="checkTxtFile"
                :show-file-list="false"
                accept=".txt"
              >
                <el-button slot="trigger" type="primary">
                  <i class="el-icon-upload"></i>
                  上传CA/AU库存报告
                </el-button>
              </el-upload>
              <span v-if="targetFileName" style="margin-left: 10px; color: #67c23a;">{{ targetFileName }}</span>
            </el-col>
            <el-col :span="8">
              <el-select placeholder="选择目标站点" v-model="targetSite" style="width: 200px;">
                <el-option label="加拿大 (CA)" value="CA"></el-option>
                <el-option label="澳大利亚 (AU)" value="AU"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-col :span="6">
              <el-input-number v-model="shippingFee" :min="0" :max="1000" :step="1" placeholder="运费" />
            </el-col>
            <el-col :span="6">
              <el-input-number v-model="exchangeRate" :min="0.01" :max="10" :step="0.01" placeholder="汇率" />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="compareInventory" :disabled="!usData.length || !targetData.length || !targetSite">
                <i class="el-icon-refresh"></i>
                执行对比
              </el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="success" @click="downloadResult" :disabled="!resultData.length">
                <i class="el-icon-download"></i>
                下载结果文件
              </el-button>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-col :span="12">
              <el-card>
                <div slot="header">
                  <span>规则1结果 (US库存为0或不存在，CA/AU有库存)</span>
                  <span style="float: right; color: #909399;">共 {{ rule1Data.length }} 条</span>
                </div>
                <el-table :data="rule1Data" style="font-size: 12px;">
                  <el-table-column label="SKU" prop="sku" width="250px" />
                  <el-table-column label="Price" prop="price" width="80px" />
                  <el-table-column label="Min Price" prop="minPrice" width="100px" />
                  <el-table-column label="Max Price" prop="maxPrice" width="100px" />
                  <el-table-column label="CA/AU库存" prop="caAuQuantity" width="80px" />
                  <el-table-column label="操作" width="80px">
                    <template slot-scope="scope">
                      <el-button size="mini" type="danger" icon="el-icon-delete" @click="removeRule1Row(scope.$index)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card>
                <div slot="header">
                  <span>规则2结果 (SKU相同，同步价格)</span>
                  <span style="float: right; color: #909399;">共 {{ rule2Data.length }} 条</span>
                </div>
                <el-table :data="rule2Data" style="font-size: 12px;">
                  <el-table-column label="SKU" prop="sku" width="250px" />
                  <el-table-column label="US Price" prop="usPrice" width="100px" />
                  <el-table-column label="Target Price" prop="price" width="100px" />
                  <el-table-column label="Min Price" prop="minPrice" width="120px" />
                  <el-table-column label="Max Price" prop="maxPrice" width="120px" />
                  <el-table-column label="Quantity" prop="quantity" width="80px" />
                </el-table>
              </el-card>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-card>
              <div slot="header">
                <span>合并结果预览 (库存调整格式)</span>
                <span style="float: right; color: #909399;">共 {{ resultData.length }} 条</span>
              </div>
              <el-table :data="resultData" style="font-size: 12px;">
                <el-table-column label="sku" prop="sku" width="300px" />
                <el-table-column label="price" prop="price" width="100px" />
                <el-table-column label="minimum-seller-allowed-price" prop="minPrice" width="180px" />
                <el-table-column label="maximum-seller-allowed-price" prop="maxPrice" width="180px" />
                <el-table-column label="quantity" prop="quantity" width="80px" />
                <el-table-column label="handling-time" prop="handlingTime" width="120px" />
                <el-table-column label="fulfillment-channel" prop="fulfillmentChannel" width="150px" />
              </el-table>
            </el-card>
          </el-row>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      targetSite: "",
      shippingFee: 10,
      exchangeRate: 1.42,
      usData: [],
      targetData: [],
      usFileName: "",
      targetFileName: "",
      rule1Data: [],
      rule2Data: [],
      resultData: [],
      // 默认配置
      defaultConfigs: {
        CA: { shippingFee: 10, exchangeRate: 1.42 },
        AU: { shippingFee: 150, exchangeRate: 1.44 }
      }
    };
  },
  watch: {
    targetSite(newVal) {
      if (newVal && this.defaultConfigs[newVal]) {
        this.shippingFee = this.defaultConfigs[newVal].shippingFee;
        this.exchangeRate = this.defaultConfigs[newVal].exchangeRate;
      }
    }
  },
  mounted() {},
  methods: {
    checkTxtFile(file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension !== "txt") {
        this.$message.error("只能上传txt文本文件");
        return false;
      }
      return false;
    },
    loadUSFile(file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension !== "txt") {
        this.$message.error("只能上传txt文本文件");
        return;
      }
      this.usFileName = file.raw.name;
      this.readTxtFile(file.raw, data => {
        this.usData = data;
        this.$message.success(`US库存报告加载成功，共 ${data.length} 条记录`);
      });
    },
    loadTargetFile(file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension !== "txt") {
        this.$message.error("只能上传txt文本文件");
        return;
      }
      this.targetFileName = file.raw.name;
      this.readTxtFile(file.raw, data => {
        this.targetData = data;
        this.$message.success(`CA/AU库存报告加载成功，共 ${data.length} 条记录`);
      });
    },
    readTxtFile(file, callback) {
      const reader = new FileReader();
      reader.onload = e => {
        const content = e.target.result;
        const data = this.parseTxtContent(content);
        callback(data);
      };
      reader.onerror = () => {
        this.$message.error("文件读取失败，请重试");
      };
      reader.readAsText(file, "UTF-8");
    },
    parseTxtContent(content) {
      const lines = content.split(/\r?\n/);
      const result = [];
      // 跳过表头行
      let skipFirst = true;
      for (let line of lines) {
        line = line.trim();
        if (!line) continue;
        if (skipFirst && line.toLowerCase().includes("seller-sku")) {
          skipFirst = false;
          continue;
        }
        // 使用正则匹配四部分：seller-sku(可能含连字符)、asin(字母数字)、price(数字)、quantity(数字)
        // seller-sku可能包含特殊字符，直到遇到连续空格分隔
        const parts = line.match(/^([^\s]+)\s+([^\s]+)\s+([\d.]+)\s+(\d+)$/);
        if (parts && parts.length === 5) {
          result.push({
            sku: parts[1],
            asin: parts[2],
            price: parseFloat(parts[3]),
            quantity: parseInt(parts[4])
          });
        } else {
          // 尝试另一种解析方式：按空格分割，取前四个部分
          const splitParts = line.split(/\s+/);
          if (splitParts.length >= 4) {
            result.push({
              sku: splitParts[0],
              asin: splitParts[1],
              price: parseFloat(splitParts[2]),
              quantity: parseInt(splitParts[3])
            });
          }
        }
      }
      return result;
    },
    compareInventory() {
      if (!this.usData.length || !this.targetData.length) {
        this.$message.warning("请先上传两份库存报告");
        return;
      }
      if (!this.targetSite) {
        this.$message.warning("请选择目标站点");
        return;
      }
      // 构建US数据的SKU索引
      const usMap = {};
      for (let item of this.usData) {
        usMap[item.sku] = item;
      }
      // 构建目标数据的SKU索引
      const targetMap = {};
      for (let item of this.targetData) {
        targetMap[item.sku] = item;
      }
      this.rule1Data = [];
      this.rule2Data = [];
      this.resultData = [];
      // 遍历目标数据，查找匹配的SKU
      for (let sku in targetMap) {
        const usItem = usMap[sku];
        const targetItem = targetMap[sku];
        // 规则1：US库存为0或不存在，但CA/AU有库存
        if (targetItem.quantity > 0 && (!usItem || usItem.quantity === 0)) {
          let calcPrice, minPrice, maxPrice;
          if (usItem) {
            // US存在，按公式计算
            calcPrice = Math.ceil(this.calculatePrice(usItem.price));
            minPrice = (calcPrice * 2 / 3).toFixed(2);
            maxPrice = (calcPrice * 1.5).toFixed(2);
          } else {
            // US不存在，使用CA/AU价格
            calcPrice = Math.ceil(targetItem.price);
            minPrice = (calcPrice * 2 / 3).toFixed(2);
            maxPrice = (calcPrice * 1.5).toFixed(2);
          }
          const record = {
            sku: sku,
            asin: targetItem.asin,
            price: calcPrice.toString(),
            minPrice: minPrice,
            maxPrice: maxPrice,
            quantity: 0,
            caAuQuantity: targetItem.quantity,
            handlingTime: "1",
            fulfillmentChannel: "DEFAULT"
          };
          this.rule1Data.push(record);
          this.resultData.push(record);
        }
        if (!usItem) continue;
        // 计算价格，向上取整
        const calcPrice = Math.ceil(this.calculatePrice(usItem.price));
        const minPrice = (calcPrice * 2 / 3).toFixed(2);
        const maxPrice = (calcPrice * 1.5).toFixed(2);
        // 规则2：SKU相同的记录
        const rule2Record = {
          sku: sku,
          asin: targetItem.asin,
          usPrice: usItem.price,
          price: calcPrice.toString(),
          minPrice: minPrice,
          maxPrice: maxPrice,
          quantity: targetItem.quantity,
          handlingTime: "1",
          fulfillmentChannel: "DEFAULT"
        };
        this.rule2Data.push(rule2Record);
        // 规则2的记录如果不在规则1中，添加到结果
        if (!(usItem.quantity === 0 && targetItem.quantity > 0)) {
          this.resultData.push(rule2Record);
        }
      }
      this.$message.success(`对比完成！规则1: ${this.rule1Data.length} 条，规则2: ${this.rule2Data.length} 条`);
    },
    calculatePrice(usPrice) {
      return (usPrice + this.shippingFee) * this.exchangeRate;
    },
    removeRule1Row(index) {
      const item = this.rule1Data[index];
      if (item) {
        this.rule1Data.splice(index, 1);
        // 同时从resultData中移除
        const resultIndex = this.resultData.findIndex(r => r.sku === item.sku);
        if (resultIndex > -1) {
          this.resultData.splice(resultIndex, 1);
        }
      }
    },
    downloadResult() {
      if (!this.resultData.length) return;
      // 生成图3格式的文本文件，handling-time和fulfillment-channel留空
      let content = "sku\tprice\tminimum-seller-allowed-price\tmaximum-seller-allowed-price\tquantity\thandling-time\tfulfillment-channel\n";
      for (let item of this.resultData) {
        content += `${item.sku}\t${item.price}\t${item.minPrice}\t${item.maxPrice}\t${item.quantity}\t\t\n`;
      }
      const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `inventory_adjustment_${this.targetSite}_${new Date().toISOString().split("T")[0]}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style>
.el-table th, .el-table td {
  padding: 6px 8px;
}
</style>
